module.exports = __webpack_public_path__ + "img/produit_4.eeb60b73.png";